namespace SPA
{
	export namespace BWS
	{
		//
	}
}
